(function () {
  const inventoryDataEl = document.getElementById('variant-inventory-data');
  if (!inventoryDataEl) return;

  const inventoryData = JSON.parse(inventoryDataEl.textContent);

  function updateVariantStyles() {
    Object.entries(inventoryData).forEach(([variantId, qty]) => {
      const input = document.querySelector(`input[data-variant-id="${variantId}"]`);
      if (!input) return;

      if (qty <= 0) {
        input.dataset.optionAvailable = 'false';
        input.closest('label')?.classList.add('variant-option__button-label--sold-out');
      } else {
        input.dataset.optionAvailable = 'true';
        input.closest('label')?.classList.remove('variant-option__button-label--sold-out');
      }
    });
  }

  document.addEventListener('variant:update', (event) => {
    const variantId = event.detail?.resource?.id;
    if (!variantId) return;

    const qty = inventoryData[String(variantId)];
    const addToCartBtn = document.querySelector('product-form-component [name="add"]');

    if (typeof qty !== 'undefined' && qty <= 0) {
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold Out';
      }
    } else {
      if (addToCartBtn) addToCartBtn.disabled = false;
    }

    updateVariantStyles();
  });

  // Run on page load too
  updateVariantStyles();
})();
